import type { SVGProps } from 'react';
type ZinniaSvgProps = SVGProps<SVGSVGElement> & {
  size: number | string,
};
const SvgArrowZoomReverse = (props: ZinniaSvgProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    height={props.size}
    width={props.size}
    {...props}
  >
    <path
      fill="#88827E"
      d="m20 10 2-2h-4.59l4.3-4.29-1.42-1.42L16 6.59V2l-2 2v6h6ZM10 10V4L8 2v4.59l-4.29-4.3-1.42 1.42L6.59 8H2l2 2h6ZM16 17.41l4.29 4.3 1.42-1.42-4.3-4.29H22l-2-2h-6v6l2 2v-4.59ZM2.29 20.29l1.42 1.42L8 17.41V22l2-2v-6H4l-2 2h4.59l-4.3 4.29Z"
    />
  </svg>
);
export default SvgArrowZoomReverse;
